import { SET_CHAT_STATE } from '../../constants/ActionTypes';


export default function setChatState(value) {
  return {
    type: SET_CHAT_STATE,
    payload: value
  }
}

